import axios from 'axios';
import config from '../../../config';

const revenuDataApi = async ([googleIdToken, userEmail, userPBIRole]) => {
	try {
		const result = await axios.get(`${config.apiURL}/getRevenueData`, {
			headers: {
				Authorization: `Bearer ${googleIdToken}`,
				userEmail,
				userPBIRole,
			},
		});
		return result?.data || {};
	} catch (err) {
		return {};
	}
};

const addRevenueProjectionsApi = async ([googleIdToken, payload]) => {
	try {
		const result = await axios.post(
			`${config.apiURL}/revenue`,
			{
				payload,
			},
			{
				headers: {
					Authorization: `Bearer ${googleIdToken}`,
				},
			}
		);
		return result;
	} catch (err) {
		return err;
	}
};

const updateRevenueProjectionsApi = async ([googleIdToken, payload, ID]) => {
	try {
		const result = await axios.put(
			`${config.apiURL}/revenue/${ID}`,
			{
				payload,
			},
			{
				headers: {
					Authorization: `Bearer ${googleIdToken}`,
				},
			}
		);
		return result;
	} catch (err) {
		return err;
	}
};

export default revenuDataApi;

export {addRevenueProjectionsApi, updateRevenueProjectionsApi};
